import React from 'react';

interface CenterProps {
  children: React.ReactNode;
  value?: any;
}

const Center = ({ children, value }: CenterProps) => {
  return (
    <>
      <div style={{ textAlign: 'center' }}>{children}</div>
    </>
  );
};

export default Center;
